query MobileSdkTestDetails($runId: ConditionID!) {
	msdk_report_runs(run_id_eq: $runId) {
		test_name
		run_time
		custom_fields
		app
        app_id
		app_version
		sdk_type
		product_version
		mobile_kit
		device_manufacturer
		device_model
		device_type
		os
		os_version
		app_build_number
	}
}
